// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-color-palette-picker .color-palette-preset-colors-item {
  height: 50px;
  width: 50px;
  float: left;
  cursor: pointer;
  border: none;
  padding: 0;
  margin: 0;
}
.fi-color-palette-picker .selected-color-preview {
  height: 25px;
  margin-top: 10px;
}
.fi-color-palette-picker .color-input-wrapper {
  margin-top: 10px;
  color: var(--fi-color-default);
}
.fi-color-palette-picker .color-input {
  border: 1px solid var(--fi-border-color-light);
  border-radius: 3px;
  width: 60px;
  padding: 0 5px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-color-palette-picker/fi-color-palette-picker.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;AAAR;AAGI;EACI,YAAA;EACA,gBAAA;AADR;AAII;EACI,gBAAA;EACA,8BAAA;AAFR;AAKI;EACI,8CAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AAHR","sourcesContent":[".fi-color-palette-picker {\r\n    .color-palette-preset-colors-item {\r\n        height: 50px;\r\n        width: 50px;\r\n        float: left;\r\n        cursor: pointer;\r\n        border: none;\r\n        padding: 0;\r\n        margin: 0;\r\n    }\r\n\r\n    .selected-color-preview {\r\n        height: 25px;\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .color-input-wrapper {\r\n        margin-top: 10px;\r\n        color: var(--fi-color-default);\r\n    }\r\n\r\n    .color-input {\r\n        border: 1px solid var(--fi-border-color-light);\r\n        border-radius: 3px;\r\n        width: 60px;\r\n        padding: 0 5px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
